import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GroupCard } from "@/components/Cards";
import api from "@/lib/api";

export default function Browse() {
    const { t } = useTranslation();
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        api.get("/public/product-groups").then((r) => setGroups(r.data));
    }, []);

    return (
        <>
            <section className="bg-white border-b border-navy-100/50">
                <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-20">
                    <div className="text-xs uppercase tracking-[0.3em] text-gold-600 mb-3">
                        {t("browse.eyebrow")}
                    </div>
                    <h1 className="font-display text-5xl md:text-6xl text-navy-700 max-w-3xl leading-[1.05]">
                        {t("browse.title")}
                    </h1>
                    <p className="text-navy-500 max-w-xl mt-5 leading-relaxed">
                        {t("browse.subtitle")}
                    </p>
                </div>
            </section>
            <section className="py-16 bg-cream">
                <div className="mx-auto max-w-7xl px-6 lg:px-10">
                    <div
                        data-testid="browse-groups-grid"
                        className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
                    >
                        {groups.map((g) => (
                            <GroupCard key={g.id} group={g} to={`/browse/${g.id}`} />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
